import React, {useMemo} from 'react';
import {FilterDef, FinalTable, FinalTableColumn, FinalTableFiltersDef, ListPage, useFinalTable} from '@mc/ui-v4';
import {DAVKA_DTM_PAGE_KEY} from '../const/PageKeys';
import {GridDtmPrenosVO, GridFilterDtmPrenosVO, MapioDtmApi} from '../api';
import {DataRequestVO, DataResponseVO} from '@mc/data-filter-react';
import {DAVKY_DTM_FT_KEY} from '../const/FinalTableKeys';
import {DAVKY_DTM_SETTINGS_KEY} from '../const/SettingsKeys';
import {getEnumStavPrenosDtmCaption, getEnumStavPrenosDtmItems} from '../enums/EnumStavPrenosDtm';
import {getEnumTypVysledekDtmCaption, getEnumTypVysledekDtmItems} from '../enums/EnumTypVysledekDtm';
import {getDtmDetailUrl} from '../utils/urlRedirectUtils';

type Props = {};
export const DavkyDtmPage: React.FC<Props> = () => {
    const filters = React.useMemo<FinalTableFiltersDef>(() => {
        const filtersDef: FilterDef[] = [
            {
                name: 'stavPrenos',
                type: 'multiSelect',
                label: 'Stav',
                multiSelectProps: {
                    items: getEnumStavPrenosDtmItems(),
                },
            },
            {
                name: 'datum',
                type: 'dateTimeRange',
                label: 'Datum',
            },
            {
                name: 'vysledek',
                type: 'multiSelect',
                label: 'Výsledek',
                multiSelectProps: {
                    items: getEnumTypVysledekDtmItems(),
                },
            },
        ];
        return {filtersDef};
    }, []);

    const columns = useMemo<FinalTableColumn<GridDtmPrenosVO>[]>(() => {
        return [
            {
                header: 'Datum',
                accessor: 'datum',
                type: 'date',
                width: '25%',
                sortable: true,
                groupable: true,
            },
            {
                header: 'Stav',
                accessor: 'stavPrenosu',
                type: 'text',
                width: '25%',
                sortable: true,
                groupable: true,
                cell: ({row}) => (row?.stavPrenosu ? getEnumStavPrenosDtmCaption(row?.stavPrenosu) : ''),
            },
            {
                header: 'Výsledek',
                accessor: 'vysledek',
                type: 'text',
                width: '25%',
                sortable: true,
                groupable: true,
                cell: ({row}) => (row?.vysledek ? getEnumTypVysledekDtmCaption(row?.vysledek) : ''),
            },
            {
                header: 'Chyba',
                accessor: 'chyba',
                type: 'text',
                width: '25%',
                sortable: true,
                groupable: true,
            },
        ];
    }, []);

    const dtmPrenosFinalTable = useFinalTable<GridDtmPrenosVO, GridFilterDtmPrenosVO, number>(DAVKY_DTM_FT_KEY, {
        settingsKey: DAVKY_DTM_SETTINGS_KEY,
        api: async (request: DataRequestVO<GridFilterDtmPrenosVO>): Promise<DataResponseVO<GridDtmPrenosVO>> =>
            (await MapioDtmApi.findPrenosByFilter(request)).data,
        filters,
        columns,
    });

    return (
        <ListPage currentPage={DAVKA_DTM_PAGE_KEY}>
            <FinalTable<GridDtmPrenosVO, GridFilterDtmPrenosVO, number>
                className={'w-100'}
                title={'Přehled změn DTM'}
                finalTableProps={dtmPrenosFinalTable}
                getRowProps={({row}) => {
                    const to = row && getDtmDetailUrl(row?.id);
                    return {
                        link: {to},
                    };
                }}
            />
        </ListPage>
    );
};
